const demographicAll = require("../geodata/demographicAll.json");
const tachlua = require("../geodata/tachlua.json");
const purpple_tav = require("../geodata/purpple_tav.json");
const treesgis = require("../geodata/treesgis.json");
const treesmit = require("../geodata/treesmit.json");
const meter = require("../geodata/100meter.json");
const sadna = require("../geodata/sadna.json");
const lamasHigh = require("../geodata/lamas_high.json");
const lamasMedium = require("../geodata/lamas_medium.json");
const lamasLow = require("../geodata/lamas_low.json");

export const layerData = [
  {
    type: "fill",
    buttonsId: ["bc"],
    id: "lamasLow",
    data: lamasLow,
    indexColor: "#1d1b84",
    label: "incomeLow",
    fillPaint: {
      "fill-color": "#262092",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    transition: {
      name: "lamasLow-fill",
      property: "fill-opacity",
      value: 0.45,
      delay: { bc: 300 },
    },
  },
  {
    type: "fill",
    buttonsId: ["bc"],
    id: "lamasMedium",
    data: lamasMedium,
    indexColor: "#312a8c",
    label: "incomeMedium",
    fillPaint: {
      "fill-color": "#262092",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    transition: {
      name: "lamasMedium-fill",
      property: "fill-opacity",
      value: 0.3,
      delay: { bc: 900 },
    },
  },
  {
    type: "fill",
    buttonsId: ["bc"],
    id: "lamasHigh",
    data: lamasHigh,
    indexColor: "#6d6bc2",
    label: "incomeHigh",
    fillPaint: {
      "fill-color": "#262092",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    transition: {
      name: "lamasHigh-fill",
      property: "fill-opacity",
      value: 0.15,
      delay: { bc: 1300 },
    },
  },
  {
    type: "circle",
    buttonsId: ["bc"],
    id: "treesgis",
    data: treesgis,
    indexColor: "#0afa42",
    label: "trees",
    circlePaint: {
      "circle-color": [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        12,
        "#0afa42",
        15,
        "#1dc945",
      ],
      "circle-radius": [
        "interpolate",
        ["exponential", 0.3],
        ["zoom"],
        14,
        1,
        16,
        5,
      ],
      "circle-opacity": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        14,
        0,
        15,
        0.8,
      ],
    },
    circleLayout: {
      visibility: "visible",
    },
  },
  {
    type: "circle",
    buttonsId: ["bc"],
    id: "treesmit",
    data: treesmit,
    circlePaint: {
      "circle-color": [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        12,
        "#0afa42",
        15,
        "#9fe916",
      ],
      "circle-radius": [
        "interpolate",
        ["exponential", 0.3],
        ["zoom"],
        14,
        1,
        16,
        5,
      ],
      "circle-opacity": [
        "interpolate",
        ["exponential", 1],
        ["zoom"],
        14,
        0,
        15,
        0.8,
      ],
    },
    circleLayout: {
      visibility: "visible",
    },
  },
  {
    type: "fill",
    buttonsId: ["lc"],
    id: "106infoPrecent",
    data: demographicAll,
    indexColor: "#3333e1",
    label: "106InfoPrecent",
    fillPaint: {
      "fill-color": "#4c237b",
      "fill-opacity": ["get", "InfoCallsPercentage"],
    },
    fillLayout: {
      visibility: "none",
    },
  },
  {
    type: "fill",
    buttonsId: ["lc"],
    id: "106helpPrecent",
    data: demographicAll,
    indexColor: "#03a3fb",
    label: "106HelpPrecent",
    fillPaint: {
      "fill-color": "#6bc4f6",
      "fill-opacity": ["get", "HelpAndFoodCallsPercentage"],
    },
    fillLayout: {
      visibility: "none",
    },
  },
  {
    type: "fill",
    buttonsId: ["lc"],
    id: "106violationPrecent",
    data: demographicAll,
    indexColor: "#67daef",
    label: "106ViolationPrecent",
    fillPaint: {
      "fill-color": "#6be4f6",
      "fill-opacity": ["get", "CovidReportingCallsPercentage"],
    },
    fillLayout: {
      visibility: "none",
    },
  },

  {
    type: "fill",
    buttonsId: ["help"],
    id: "106helpLow",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) => x.properties.HelpAndFoodCalls < x.properties.maxHelpCalls / 3
      ),
    },
    indexColor: "#6bc4f6",
    label: "106Help",
    fillPaint: {
      "fill-color": "#6bc4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106help",
    fillOnMouseMove: "HelpAndFoodCalls",
    transition: {
      name: "106helpLow-fill",
      property: "fill-opacity",
      value: 0.2,
      delay: { help: 1500 },
    },
  },
  {
    type: "fill",
    buttonsId: ["help"],
    id: "106helpMedium",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) =>
          x.properties.HelpAndFoodCalls > x.properties.maxHelpCalls / 3 &&
          x.properties.HelpAndFoodCalls < x.properties.maxHelpCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#6bc4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106help",
    fillOnMouseMove: "HelpAndFoodCalls",
    transition: {
      name: "106helpMedium-fill",
      property: "fill-opacity",
      value: 0.45,
      delay: { help: 1000 },
    },
  },
  {
    type: "fill",
    buttonsId: ["help"],
    id: "106helpHigh",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) => x.properties.HelpAndFoodCalls > x.properties.maxHelpCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#6bc4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106help",
    fillOnMouseMove: "HelpAndFoodCalls",
    transition: {
      name: "106helpHigh-fill",
      property: "fill-opacity",
      value: 0.7,
      delay: { help: 500 },
    },
  },
  {
    type: "fill",
    buttonsId: ["info"],
    id: "106infoLow",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) => x.properties.InfoCalls < x.properties.maxInfoCalls / 3
      ),
    },
    indexColor: "#4c237b",
    label: "106Info",
    fillPaint: {
      "fill-color": "#4c237b",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106info",
    fillOnMouseMove: "InfoCalls",
    transition: {
      name: "106infoLow-fill",
      property: "fill-opacity",
      value: 0.2,
      delay: { info: 1500 },
    },
  },
  {
    type: "fill",
    buttonsId: ["info"],
    id: "106infoMedium",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) =>
          x.properties.maxInfoCalls / 3 < x.properties.InfoCalls &&
          x.properties.InfoCalls < x.properties.maxInfoCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#4c237b",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106info",
    fillOnMouseMove: "InfoCalls",
    transition: {
      name: "106infoMedium-fill",
      property: "fill-opacity",
      value: 0.45,
      delay: { info: 1000 },
    },
  },
  {
    type: "fill",
    buttonsId: ["info"],
    id: "106infoHigh",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) => x.properties.InfoCalls > x.properties.maxInfoCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#4c237b",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106info",
    fillOnMouseMove: "InfoCalls",
    transition: {
      name: "106infoHigh-fill",
      property: "fill-opacity",
      value: 0.9,
      delay: { info: 200 },
    },
  },
  {
    type: "fill",
    buttonsId: ["info"],
    id: "meter",
    data: meter,
    indexColor: "#6bc4f6",
    label: "meterGreen",
    fillPaint: {
      "fill-color": "#6bc4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    transition: {
      name: "meter-fill",
      property: "fill-opacity",
      value: 0.2,
      delay: { info: 2300 },
    },
  },

  {
    type: "fill",
    buttonsId: ["violation"],
    id: "106violationLow",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) => x.properties.CovidReportingCalls < x.properties.maxCovidCalls / 3
      ),
    },
    indexColor: "#6be4f6",
    label: "106Violation",
    fillPaint: {
      "fill-color": "#6be4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106violation",
    fillOnMouseMove: "CovidReportingCalls",
    transition: {
      name: "106violationLow-fill",
      property: "fill-opacity",
      value: 0.2,
      delay: { violation: 1500 },
    },
  },

  {
    type: "fill",
    buttonsId: ["violation"],
    id: "106violationMedium",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) =>
          x.properties.CovidReportingCalls > x.properties.maxCovidCalls / 3 &&
          x.properties.CovidReportingCalls < x.properties.maxCovidCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#6be4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106violation",
    fillOnMouseMove: "CovidReportingCalls",
    transition: {
      name: "106violationMedium-fill",
      property: "fill-opacity",
      value: 0.45,
      delay: { violation: 1000 },
    },
  },

  {
    type: "fill",
    buttonsId: ["violation"],
    id: "106violationHigh",
    data: {
      type: "FeatureCollection",
      features: demographicAll["features"].filter(
        (x) =>
          x.properties.CovidReportingCalls > x.properties.maxCovidCalls * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#6be4f6",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "106violation",
    fillOnMouseMove: "CovidReportingCalls",
    transition: {
      name: "106violationHigh-fill",
      property: "fill-opacity",
      value: 0.7,
      delay: { violation: 500 },
    },
  },

  {
    type: "fill",
    buttonsId: ["covidReport"],
    id: "covidReportLow",
    data: {
      type: "FeatureCollection",
      features: sadna["features"].filter(
        (x) => x.properties.num_reports < x.properties.max_reports / 3
      ),
    },
    indexColor: "#fa8a6b",
    label: "selfReporting",
    fillPaint: {
      "fill-color": "#faa77a",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "covidReport",
    fillOnMouseMove: "num_reports",
    transition: {
      name: "covidReportLow-fill",
      property: "fill-opacity",
      value: 0.6,
      delay: { covidReport: 500 },
    },
  },

  {
    type: "fill",
    buttonsId: ["covidReport"],
    id: "covidReportMedium",
    data: {
      type: "FeatureCollection",
      features: sadna["features"].filter(
        (x) =>
          x.properties.num_reports > x.properties.max_reports / 3 &&
          x.properties.num_reports < x.properties.max_reports * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#fa8a6b",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "covidReport",
    fillOnMouseMove: "num_reports",
    transition: {
      name: "covidReportMedium-fill",
      property: "fill-opacity",
      value: 0.6,
      delay: { covidReport: 1000 },
    },
  },

  {
    type: "fill",
    buttonsId: ["covidReport"],
    id: "covidReportHigh",
    data: {
      type: "FeatureCollection",
      features: sadna["features"].filter(
        (x) => x.properties.num_reports > x.properties.max_reports * 0.66
      ),
    },
    fillPaint: {
      "fill-color": "#eb6b6b",
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1500,
      },
    },
    fillLayout: {
      visibility: "none",
    },
    flyOverId: "covidReport",
    fillOnMouseMove: "num_reports",
    transition: {
      name: "covidReportHigh-fill",
      property: "fill-opacity",
      value: 0.6,
      delay: { covidReport: 1500 },
    },
  },

  {
    type: "fill",
    buttonsId: ["help", "covidReport", "nc"],
    id: "demographicage",
    data: demographicAll,
    indexColor: "#7c328b",
    label: "demographicAge",
    fillLayout: { visibility: "none" },
    fillPaint: {
      "fill-color": [
        "case",
        [
          "all",
          [">", ["get", "over60percentage"], 20],
          ["<", ["get", "over60percentage"], 30],
        ],
        "#aa64a3",
        [
          "all",
          [">", ["get", "over60percentage"], 30],
          ["<", ["get", "over60percentage"], 60],
        ],
        "#7c328b",
        ["all", [">", ["get", "over60percentage"], 70]],
        "#4c237b",
        "transparent",
      ],
      "fill-opacity": 0,
      "fill-opacity-transition": {
        duration: 1000,
      },
    },
    transition: {
      name: "demographicage-fill",
      property: "fill-opacity",
      value: 0.5,
      delay: { help: 2000, covidReport: 2000, nc: 1700 },
    },
  },

  {
    type: "line",
    buttonsId: ["lc", "violation", "help", "info", "covidReport"],
    id: "demographicAll",
    data: demographicAll,
    lineLayout: { visibility: "none" },
    linePaint: {
      "line-color": "#a9a9a9",
      "line-width": [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        14,
        0.75,
        16,
        1,
      ],
      "line-opacity": 0,
      "line-opacity-transition": {
        duration: 700,
      },
    },
    transition: {
      name: "demographicAll-line",
      property: "line-opacity",
      value: 0.6,
      delay: {
        lc: 700,
        violation: 2000,
        help: 2700,
        info: 2500,
        covidReport: 2500,
      },
    },
  },
  {
    type: "circle",
    buttonsId: ["nc"],
    id: "purpple",
    data: purpple_tav,
    indexColor: "#932fb1",
    label: "purpple",
    circlePaint: {
      "circle-color": "#932fb1",
      "circle-radius": [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        11.3,
        0.4,
        16,
        4,
      ],
      "circle-opacity": 0,
      "circle-opacity-transition": {
        duration: 1500,
      },
    },
    circleLayout: {
      visibility: "none",
    },
    transition: {
      name: "purpple-circle",
      property: "circle-opacity",
      value: [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        11.3,
        0.5,
        15,
        0.8,
      ],
      delay: { nc: 1200 },
    },
  },
  {
    type: "circle",
    buttonsId: ["nc", "covidReport", "lc", "help", "violation", "info"],
    id: "tachlua",
    data: tachlua,
    indexColor: "#f91515",
    label: "tachlua",
    circlePaint: {
      "circle-color": "#f91515",
      "circle-opacity": 0,
      "circle-radius": [
        "interpolate",
        ["exponential", 0.5],
        ["zoom"],
        11,
        0.7,
        16,
        4,
      ],
      "circle-opacity-transition": {
        duration: 1500,
      },
    },
    circleLayout: {
      visibility: "none",
    },
    transition: {
      name: "tachlua-circle",
      property: "circle-opacity",
      value: ["interpolate", ["exponential", 0.2], ["zoom"], 11, 0.5, 14, 1],
      delay: {
        nc: 700,
        lc: 500,
        violation: 2500,
        help: 3000,
        info: 2700,
        covidReport: 3000,
      },
    },
  },
];
